import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  dialogPaper: {
    background: themeColor.modalBackground,
  },
  mainContainer: {
    flexGrow: 1,
    paddingBottom: '4.25vh',
  },
  title: {
    border: `solid 1px ${themeColor.modalBackground}`,
    borderRadius: '2px',
    height: '9.83vh',
    padding: '1vh 1.15vw',
  },
  titleContent: {
    fontSize: rem(2),
    fontWeight: 500,
  },
  titleContainer: {
    marginTop: '2.71vh',
  },
  actionButton: {
    width: '95%',
    height: '5.68vh',
    fontSize: rem(1.143),
    lineHeight: '0.11vh',
    letterSpacing: '0.11vw',
    '@media (aspect-ratio: 4/3)': {
      fontSize: rem(1.4),
    },
  },
  loginInputBox: {
    padding: '2vh 0',
  },
  loginFormContainer: {
    maxWidth: '32.942vw',
    '@media (aspect-ratio: 4/3)': {
      maxWidth: '37vw',
    },
  },
  loginField: {
    '& .MuiFormLabel-root': {
      paddingLeft: '0.575vw',
      fontSize: rem(1),
      color: themeColor.defaultTextColor,
    },
    '& .MuiInput-underline': {
      paddingLeft: '0.575vw',
      '&:hover:not(.Mui-disabled):before': {
        borderBottom: `0.5312084993359893vh solid ${theme.palette.secondary.main}`,
      },
      '&:after': {
        borderBottom: `0.5312084993359893vh solid ${theme.palette.secondary.main}`,
      },
    },
    '& .MuiFormLabel-root.Mui-error': {
      color: themeColor.alert,
    },
    '& .MuiInput-underline.Mui-error': {
      paddingLeft: '0.575vw',
      '&:hover:not(.Mui-disabled):before': {
        borderBottom: `0.5312084993359893vh solid ${themeColor.alert}`,
      },
      '&:after': {
        borderBottom: `0.5312084993359893vh solid ${themeColor.alert}`,
      },
    },
    '& .MuiOutlinedInput-root': {
      width: '100%',
      '& fieldset': {
        borderRadius: '2px',
      },
    },
    height: '8.9vh',
  },
  loginFieldTraining: {
    '& .MuiInput-underline': {
      '&:hover:not(.Mui-disabled):before': {
        borderBottom: `0.5312084993359893vh solid ${theme.palette.secondary.main}`,
      },
      '&:after': {
        borderBottom: `0.5312084993359893vh solid ${theme.palette.secondary.main}`,
      },
    },
    '& .MuiOutlinedInput-root': {
      width: '100%',
      height: '61%',
      '& fieldset': {
        borderRadius: '0.376% / 3.98%',
      },
    },
    height: '9.64vh',
  },
  storeLogo: {
    maxWidth: '40%',
    height: '100%',
    marginRight: '0.86vw',
  },
  grayiconbutton: {
    color: themeColor.subheaderLight,
  },
  rediconbutton: {
    color: themeColor.alert,
  },
  errorMessage: {
    fontSize: rem(0.875),
    fontWeight: 400,
    letterSpacing: '0.25px',
    fontStyle: 'normal',
    '@media (aspect-ratio: 4/3)': {
      fontSize: '1.6vh',
    },
    display: 'inline-cell',
    verticalAlign: 'middle',
  },
  errorMessageContainer: {
    display: 'inline-table',
  },
  erroricon: {
    display: 'inline-block',
    height: '2.8vh',
    width: '2.3vw',
    color: themeColor.alert,
    '@media (aspect-ratio: 4/3)': {
      height: '2.3vh',
    },
    verticalAlign: 'middle',
  },
}));
